import { HotkeyCallback, Keys, useHotkeys } from "react-hotkeys-hook";

import { bowser } from "@shared/services/browserSupport";
import { getPressedKeys } from "@shared/services/hotkey";

export const HotkeyHandler = ({
  keysUp = [],
  keysDown = [],
  onHotkeyDetected,
  iframeDocument,
}: {
  keysUp?: Keys;
  keysDown?: Keys;
  onHotkeyDetected: (pressedKeys: string[]) => void;
  iframeDocument?: Document; // pass this to listen to also hotkeys within the iframe
}) => {
  const callback: HotkeyCallback = (_, hotkeyEvent) => {
    onHotkeyDetected(getPressedKeys(hotkeyEvent, bowser.getOSName(true)));
  };

  const commonOptions = {
    enableOnFormTags: true,
    enableOnContentEditable: true,
  };

  // Handle keysUp and keysDown separately to avoid double sending
  useHotkeys(keysUp, callback, {
    ...commonOptions,
    keyup: true,
    keydown: false,
  });

  useHotkeys(keysDown, callback, {
    ...commonOptions,
    keyup: false,
    keydown: true,
  });

  // if iframeDocument is provided, listen to hotkeys within the iframe
  useHotkeys(keysUp, callback, {
    ...commonOptions,
    document: iframeDocument,
    keyup: true,
    keydown: false,
  });

  useHotkeys(keysDown, callback, {
    ...commonOptions,
    document: iframeDocument,
    keyup: false,
    keydown: true,
  });

  return null;
};
